import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const PoliticaCookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mb-8 text-center">
            POLÍTICA DE COOKIES
          </h1>
          
          <div className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                1. Qué son las cookies
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Las cookies son pequeños archivos de texto que se almacenan en el dispositivo del usuario 
                al visitar un sitio web. Sirven para mejorar la experiencia de navegación y recopilar 
                información estadística de uso.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                2. Tipos de cookies utilizadas
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El sitio web www.erbaservice.com utiliza las siguientes categorías de cookies:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Cookies técnicas:</strong> necesarias para el funcionamiento básico de la web.</li>
                <li><strong>Cookies de análisis:</strong> permiten cuantificar el número de usuarios y realizar medición estadística del uso de la web (por ejemplo, Google Analytics).</li>
                <li><strong>Cookies de personalización:</strong> permiten recordar preferencias del usuario (idioma, región, etc.).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                3. Cookies de terceros
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Este sitio puede utilizar servicios de terceros como Google Analytics. Estos servicios 
                pueden recopilar información anónima sobre la navegación y su tratamiento está regulado 
                por las políticas de privacidad de sus propios titulares.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                4. Cómo desactivar las cookies
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El usuario puede configurar su navegador para aceptar, bloquear o eliminar las cookies instaladas:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Chrome:</strong> Configuración de cookies en Chrome</li>
                <li><strong>Firefox:</strong> Configuración de cookies en Firefox</li>
                <li><strong>Edge:</strong> Configuración de cookies en Edge</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                5. Aceptación de la política de cookies
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Al continuar navegando en este sitio web, el usuario consiente el uso de las cookies 
                en los términos establecidos en esta política.
              </p>
            </section>
          </div>

          <div className="text-center mt-8">
            <button 
              onClick={() => window.history.back()}
              className="bg-[#16a34a] hover:bg-[#15803d] text-white px-8 py-3 rounded-full font-semibold transition-all"
            >
              Volver
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};